export type NotePreviewKind = 'drive' | 'pdf' | 'image' | 'office' | 'unknown';

export function extractGoogleDriveFileId(url: string): string | null {
  if (!url?.trim()) return null;
  try {
    const u = new URL(url.trim());
    if (!u.hostname.includes('drive.google.com') && !u.hostname.includes('docs.google.com')) {
      return null;
    }
    const pathMatch = u.pathname.match(/\/file\/d\/([^/]+)/);
    if (pathMatch) return pathMatch[1];
    const openId = u.searchParams.get('id');
    if (openId) return openId;
    const ucMatch = u.pathname.match(/\/uc\?.*id=([^&]+)/);
    if (ucMatch) return ucMatch[1];
  } catch {
    return null;
  }
  return null;
}

export function getNotePreviewKind(fileUrl: string, fileName?: string): NotePreviewKind {
  const url = (fileUrl || '').toLowerCase();
  const name = (fileName || '').toLowerCase();
  if (extractGoogleDriveFileId(fileUrl)) return 'drive';
  if (/\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/i.test(url) || /\.(png|jpe?g|gif|webp)$/i.test(name)) {
    return 'image';
  }
  if (/\.pdf(\?|$)/i.test(url) || name.endsWith('.pdf')) return 'pdf';
  if (/\.(docx?|pptx?|xlsx?)(\?|$)/i.test(url) || /\.(docx?|pptx?|xlsx?)$/i.test(name)) {
    return 'office';
  }
  return 'unknown';
}

export function getGoogleDriveThumbnailUrl(fileId: string, width = 480): string {
  return `https://drive.google.com/thumbnail?id=${encodeURIComponent(fileId)}&sz=w${width}`;
}

export function getGoogleDrivePreviewUrl(fileId: string): string {
  return `https://drive.google.com/file/d/${fileId}/preview`;
}

export function getGoogleDriveViewUrl(fileId: string): string {
  return `https://drive.google.com/file/d/${fileId}/view`;
}
